import Phaser from 'phaser';
import {
  playCoinSound,
  playHeartCollectSound,
  playSlingCollectSound,
  playOneUpSound
} from './audio';

export function createCollectibles(scene, map) {
  const powerUpsLayer = map.getObjectLayer('Power Ups Objects');

  scene.coins     = scene.add.group();
  scene.hearts    = scene.add.group();
  scene.slingshots = scene.add.group();
  scene.oneUps    = scene.add.group();

  powerUpsLayer.objects.forEach(object => {
    let powerup;
    switch (object.gid) {
      case 105: // Coin
        powerup = scene.add.sprite(object.x, object.y, 'powerups', 0);
        powerup.powerupType = 'coin';
        scene.coins.add(powerup);
        if (!scene.anims.exists('coin-spin')) {
          scene.anims.create({
            key: 'coin-spin',
            frames: scene.anims.generateFrameNumbers('powerups', { frames: [0, 1, 2, 3] }),
            frameRate: 10,
            repeat: -1
          });
        }
        powerup.play('coin-spin');
        break;
      case 114: // Heart
        powerup = scene.add.sprite(object.x, object.y, 'powerups', 9);
        powerup.powerupType = 'heart';
        scene.hearts.add(powerup);
        break;
      case 119: // Slingshot
        powerup = scene.add.sprite(object.x, object.y, 'powerups', 14);
        powerup.powerupType = 'slingshot';
        scene.slingshots.add(powerup);
        break;
      case 117: // 1up
        powerup = scene.add.sprite(object.x, object.y, 'powerups', 12);
        powerup.powerupType = '1up';
        scene.oneUps.add(powerup);
        break;
    }
    if (powerup) powerup.setOrigin(0, 1);
  });

  // Doors
  scene.doors = scene.add.group();
  const mapData = scene.cache.tilemap.get('level0').data;
  const doorsLayerData = mapData.layers.find(l => l.name === 'Doors');
  const doorTileset = mapData.tilesets.find(ts => ts.name === 'Doors');
  if (doorsLayerData && doorTileset) {
    const firstgid = doorTileset.firstgid;
    const baseTileW = mapData.tilewidth;
    const baseTileH = mapData.tileheight;
    (doorsLayerData.chunks || []).forEach(chunk => {
      const cw = chunk.width;
      chunk.data.forEach((gid, i) => {
        if (gid !== 0) {
          const col = chunk.x + (i % cw);
          const row = chunk.y + Math.floor(i / cw);
          const x = col * baseTileW;
          const y = (row + 1) * baseTileH;
          scene.doors.add(scene.add.image(x, y, 'door', gid - firstgid).setOrigin(0, 1));
        }
      });
    });
  }
}

export function updateCollectibles(scene) {
  const pb = scene.player.body;
  scene.playerRect.setTo(pb.x, pb.y, pb.width, pb.height);
  const r = scene.playerRect;

  scene.coins.getChildren().forEach(c => {
    if (c.active && Phaser.Geom.Rectangle.Overlaps(r, c.getBounds())) {
      c.destroy(); playCoinSound(); scene.statusPanel.addCoin();
    }
  });
  scene.hearts.getChildren().forEach(c => {
    if (c.active && Phaser.Geom.Rectangle.Overlaps(r, c.getBounds())) {
      c.destroy(); playHeartCollectSound();
      scene.player.health = Math.min(scene.player.health + 1, 4);
    }
  });
  scene.slingshots.getChildren().forEach(c => {
    if (c.active && Phaser.Geom.Rectangle.Overlaps(r, c.getBounds())) {
      c.destroy(); playSlingCollectSound();
      scene.hasSlingshot = true;
      scene.slingshotAmmo = 5;
    }
  });
  scene.oneUps.getChildren().forEach(c => {
    if (c.active && Phaser.Geom.Rectangle.Overlaps(r, c.getBounds())) {
      c.destroy(); playOneUpSound(); scene.statusPanel.addLife();
    }
  });
}
